import { makePublishHelper, makeSubscribeHelper } from '../helpers-creators';

const schema = {};

export const eventRequested = makePublishHelper(
  'eventRequested',
  'wh.common.event.ui.header.deposit.requested',
  schema,
);

export const onEventRequested = makeSubscribeHelper(
  'onEventRequested',
  'wh.common.event.ui.header.deposit.requested',
  schema,
);
